/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "checking": {
                "nested": {
                  "Source": {
                    "values": {
                      "SOURCE_UNKNOWN": 0,
                      "SOURCE_BALANCE_APPLET": 1,
                      "SOURCE_BILLPAY_APPLET": 2,
                      "SOURCE_SETUP_GUIDE_LINK_BANK_ACCOUNT": 3,
                      "SOURCE_PAYMENTS_ONBOARDING": 4,
                      "SOURCE_INVOICES": 5
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking?.nested?.Source) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Source @ squareup/bbfrontend/common/checking/onboarding_source.proto at 8:1
 */
export const Source = $root.lookupEnum('squareup.bbfrontend.common.checking.Source').values;